import { useTranslation } from "react-multi-lang";
import ButtonWhite from "../../../../components/ButtonWhite/ButtonWhite";
import Action from "../../redux/Action";
import { useDispatch } from "react-redux";
import { useCallback, useState } from "react";
import ProductRepository from "../../../../repositories/ProductRepository";
import Dropzone from "./Dropzone";
import { setIncompletedProducts } from "../../redux/Reducer";

const BulkAdd = ({ onCancel }) => {
    const t = useTranslation();
    const dispatch = useDispatch();
    const [selectedFile, setSelectedFile] = useState(null);
    const [validationPart, setValidationPart] = useState(false);
    const [validatedData, setValidatedData] = useState(null);

    const handleProceed1 = async (e) => {
        e.preventDefault();

        if (!selectedFile) {
            alert("No file selected.");
            return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("validateOnly", true);

        const response = await ProductRepository.extractBulkAddProducts(formData);
        const errorStatus = response?.error;

        if (!errorStatus) {
            const data = response?.data?.data;
            setValidatedData(data);
            setValidationPart(true);
        }
    };


    const handleProceed2 = async (e) => {
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("validateOnly", false);

        const response = await ProductRepository.extractBulkAddProducts(formData);
        const data = response?.data?.data.map((item, index) => ({
            ...item,
            imageUrl: null,
            isCompleted: false,
            index
        }));
        const errorStatus = response?.error;

        if (!errorStatus) {
            Action.getPage(dispatch, { page: "incomplete-product-list" });
            dispatch(setIncompletedProducts(data ?? []));
            onCancel({ showModal: false });
        }

    };

    const handleDownloadTemplate = () => {
        Action.downloadTemplate(dispatch);
    };

    // Getter for validCount
    const getValidCount = useCallback(() => {
        return validatedData?.validCount;
    }, [validatedData]);

    // Getter for invalidCount
    const getInvalidCount = useCallback(() => {
        return validatedData?.invalidCount;
    }, [validatedData]);

    // Getter for duplicateCount
    const getDuplicateCount = useCallback(() => {
        return validatedData?.duplicateCount;
    }, [validatedData]);

    // Getter for errors
    const getErrors = useCallback(() => {
        return validatedData?.messageDetail;
    }, [validatedData]);

    const getErrorMessage = useCallback(() => {
        return validatedData?.message;
    }, [validatedData]);

    const getErrorMessageDetail = useCallback(() => {
        return validatedData?.messageDetail.join(", ");
    }, [validatedData]);

    // Getter for total of validCount, invalidCount, and duplicateCount
    const getTotalCount = useCallback(() => {
        return validatedData?.validCount + validatedData?.invalidCount + validatedData?.duplicateCount;
    }, [validatedData]);

    return (
        <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
                className="fixed inset-0 w-full h-full bg-black opacity-40"
                onClick={() => onCancel({ showModal: false })}
            />
            <div className="flex items-center min-h-screen px-4 py-8">
                <div className="relative w-full max-w-lg p-4 mx-auto bg-gray-primary rounded-xl shadow-lg">
                    {!validationPart && !validatedData ?
                        <form onSubmit={handleProceed1}>
                            <div className="m-3 text-left">
                                <h3 className="text-green-primary font-bold pb-2">Bulk Add Products</h3>
                                <div className="text-sm">
                                    Add multiple products at once by uploading the template.{" "}
                                    <span
                                        onClick={handleDownloadTemplate}
                                        className="cursor-pointer font-bold underline text-green-primary"
                                    >
                                        Download Template
                                    </span>{" "}
                                    and follow the required format.
                                </div>

                                <div className="my-5">
                                    <Dropzone selectedFile={selectedFile} setSelectedFile={setSelectedFile} />
                                </div>

                                <div className="flex justify-end gap-2 mt-3">
                                    <ButtonWhite
                                        title={t("general.cancel")}
                                        onClick={() => onCancel({ showModal: false })}
                                    />
                                    <button
                                        type="submit"
                                        className="button md:w-36 hover:bg-gray-primary hover:text-green-secondary text-xs tracking-widest font-bold text-gray-primary border-2 border-green-secondary bg-green-secondary border-opacity-40 rounded-xl py-2"
                                    >
                                        {t("general.proceed")}
                                    </button>
                                </div>
                            </div>
                        </form>
                        : (
                            <div className="m-3 text-left">
                                <h3 className="text-green-primary font-bold pb-2">Bulk Add Products</h3>

                                <p className="mt-4 text-[#7D8786] font-['Plus_Jakarta_Sans'] font-medium text-sm leading-none tracking-normal">
                                    Total Products
                                </p>
                                <h4 className="text-[#4E5554] mt-2 mb-6 font-['Plus_Jakarta_Sans'] font-[700] text-[20px] leading-[100%] tracking-[0%]">
                                    {getTotalCount()} Products
                                </h4>

                                {getDuplicateCount() > 0 && (<>
                                    <p className="text-[#7D8786] font-['Plus_Jakarta_Sans'] font-medium text-sm leading-none tracking-normal">
                                        Duplicate detected
                                    </p>
                                    <h4 className="text-[#4E5554] mt-2 mb-6 font-['Plus_Jakarta_Sans'] font-[700] text-[20px] leading-[100%] tracking-[0%]">
                                        {getDuplicateCount()} Products
                                    </h4>
                                </>)}

                                {getInvalidCount() > 0 && (<>
                                    <p className="text-[#7D8786] font-['Plus_Jakarta_Sans'] font-medium text-sm leading-none tracking-normal">
                                        Issues detected
                                    </p>
                                    <h4 className="text-[#4E5554] mt-2 mb-6 font-['Plus_Jakarta_Sans'] font-[700] text-[20px] leading-[100%] tracking-[0%]">
                                        {getInvalidCount()} Products
                                    </h4>
                                </>)}
                                <div className={`rounded-md`}>
                                    {getDuplicateCount() > 0 && <div className="rounded-md bg-white px-4 py-4 flex items-center mb-2 gap-2">
                                        <img className="w-[35px] h-[35px]" src={process.env.REACT_APP_ASSETS_IMAGE + "warning-upload.svg"} alt="" />
                                        <p className="font-['Plus_Jakarta_Sans'] font-bold text-sm leading-none tracking-normal align-middle">
                                            {getDuplicateCount()} products already exist in current list.
                                        </p>
                                    </div>}

                                    {(getErrorMessage() !== "" && getErrorMessageDetail() !== "") && (
                                        <div className="rounded-md bg-white px-4 py-4 flex items-center gap-2 mb-6">
                                            <img className="w-[35px] h-[35px]" src={process.env.REACT_APP_ASSETS_IMAGE + "issued-upload.svg"} alt="" />
                                            <div>
                                                <p className="font-['Plus_Jakarta_Sans'] mb-1 font-bold text-sm leading-none tracking-normal align-middle">
                                                    {getErrorMessage()}
                                                </p>
                                                <p className="text-[#898989] font-['Plus_Jakarta_Sans'] font-normal text-sm leading-none tracking-normal">
                                                    {getErrorMessageDetail()}
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <p className="font-['Plus_Jakarta_Sans'] mt-4 mb-6 font-normal text-base leading-none tracking-normal font-primary-seconday">
                                    Do you want to proceed the <span className="font-bold text-green-primary">{getValidCount()} products</span> ? This will add all valid items and replace any existing matching products in your current list.
                                </p>

                                <div className="flex justify-end gap-2 mt-3">
                                    <ButtonWhite
                                        title={t("general.cancel")}
                                        onClick={() => onCancel({ showModal: false })}
                                    />
                                    <button
                                        onClick={handleProceed2}
                                        disabled={getValidCount() <= 0}
                                        type="submit"
                                        className={`button md:w-36 hover:bg-gray-primary hover:text-green-secondary text-xs tracking-widest font-bold text-gray-primary border-2 border-green-secondary bg-green-secondary border-opacity-40 rounded-xl py-2 ${getValidCount() <= 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    >
                                        {t("general.proceed")} {validationPart && validatedData ? "(" + getValidCount() + ")" : ""}
                                    </button>
                                </div>
                            </div>
                        )}
                </div>
            </div>
        </div>
    );
};

export default BulkAdd;

